import React, { useState } from 'react';
import { flowRight, get } from 'lodash';
import PropTypes from 'prop-types';
import { getJson, get as getSession } from 'session';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import BarcodeScannerComponent from "react-webcam-barcode-scanner";
import * as actions from '../actions';

const Scanner = ({ profile, validate }) => {
  const [isValidating, setIsValidating] = useState(false)
  const [showResult, setShowResult] = useState(false)
  const [textResult, setTextResult] = useState(null)
  const first_name = get(profile, 'first_name', '');
  const last_name = get(profile, 'last_name', '');
  const email = get(profile, 'email', '');

  const token = getSession('token')

  const onUpdateScanner = (err, res) => {
    
    if(res){
      setIsValidating(true)
      validate({
        value: res.text
      }, () => {
        setIsValidating(false)
        setShowResult(true)
        setTextResult(res.text)
      }, () => {
        setShowResult(false)
        setIsValidating(false)
        setTextResult(false)
      })
    }
  } 

  const onScanAgain = e => {
    e.preventDefault()
    setShowResult(false)
    setIsValidating(false)
    setTextResult(false)
  }

  return (
    <div className="scanner-wrapper">
      <div className="header">
        User: {`${first_name} ${last_name}`}
      </div>
      {!showResult && !isValidating && (
        <BarcodeScannerComponent
          className="scanner-video"
          width="100%"
          height="80%"
          onUpdate={onUpdateScanner}
        />
      )}
      {isValidating && (
        <div className="scan-loading">
          <i className="fa fa-spin fa-spinner text-white" style={{ fontSize: 30 }} />
        </div>
      )}
      {showResult && !isValidating && (
        <div className="scan-result">
          <iframe 
            className="scanned-frame"
            title="Scan Result"
            src={`${process.env.REACT_APP_WS}/api/v1/administrators/qr_code/read?value=${textResult}&bearer_token=${token}&email=${email}`}   
          />
        </div>
      )}
      <div className="footer">
        {!showResult && (
          <div className="back-wrapper">
            <Link to="/"><i className="fa fa-arrow-left text-white" /></Link>
          </div>
        )}
        {showResult && (
          <div className="back-wrapper">
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a href="#" onClick={onScanAgain}><i className="fa fa-camera text-white" /></a>
          </div>
        )}
      </div>
    </div>
  )
}



Scanner.propTypes = {
  profile: PropTypes.instanceOf(Object).isRequired,
  validate: PropTypes.instanceOf(Function).isRequired
};

const mapStateToProps = () => ({
  profile: getJson('profile'),
  
});

const enhance = flowRight([
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(Scanner);